<template>
    <h4 class="adv-desc"><slot></slot></h4>
</template>
<script>
export default {
    name: 'AdvDescript'
};
</script>

<style lang="scss">
.adv-desc {
    width: 100%;
    font-size: 12px;
    line-height: 1.5;
    text-align: center;
    color: #a0a3af;
    margin: 0;
    font-weight: normal;
    a {
        color: #4c84ff;
    }
}
</style>
